<form [formGroup]="form">
  <ng-container
    [ngTemplateOutlet]="formGroupInput"
    [ngTemplateOutletContext]="{
      name: 'subscriptionId',
      description: 'Subscription Id',
      labelClass: 'form-control-label',
      inputClass: 'form-control',
      formControl: subscriptionId
    }"
  >
  </ng-container>

  <div class="form-group">
    <label for="packages">New license package *</label>
    <select id="packages" formControlName="licensePackage" class="form-control">
      <option *ngFor="let package of licensePackages" [value]="package.code">
        {{ package?.displayName }}
      </option>
    </select>
  </div>
  <ng-container
    [ngTemplateOutlet]="formGroupInput"
    [ngTemplateOutletContext]="{
      name: 'orderNumber',
      description: 'Order number',
      labelClass: 'form-control-label',
      inputClass: 'form-control',
      formControl: orderNumber
    }"
  >
  </ng-container>
</form>
<div class="footer">
  <button (click)="activeModal.close()">Cancel</button>
  <button class="btn btn-success" [disabled]="form.invalid" (click)="upgrade()">
    <i class="far fa-arrow-alt-circle-up"></i><span>Upgrade</span>
  </button>
</div>

<ng-template
  #formGroupInput
  let-name="name"
  let-description="description"
  let-labelClass="labelClass"
  let-inputClass="inputClass"
  let-formControl="formControl"
>
  <div class="form-group">
    <label [for]="name" [ngClass]="labelClass">{{ description }} *</label>
    <input
      [name]="name"
      type="text"
      maxLength="17"
      [ngClass]="inputClass"
      [formControl]="formControl"
    />
    <div
      *ngIf="formControl.invalid && (formControl.dirty || formControl.touched)"
      class="form-control-feedback text-danger"
    >
      <small *ngIf="formControl.hasError('required')"
        >{{ description }} is invalid. It should have 16 alphanumeric
        characters</small
      >
      <small *ngIf="formControl.hasError('pattern')"
        >{{ description }} is invalid. It should have 16 alphanumeric
        characters</small
      >
    </div>
  </div>
</ng-template>
